/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Compile_PdfInputs */

const en_compile_pdf = /** @type {(inputs: Compile_PdfInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Compile PDF`)
};

const es_compile_pdf = /** @type {(inputs: Compile_PdfInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Compilar PDF`)
};

const fr_compile_pdf = /** @type {(inputs: Compile_PdfInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Compiler le PDF`)
};

const de_compile_pdf = /** @type {(inputs: Compile_PdfInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PDF kompilieren`)
};

const ja_compile_pdf = /** @type {(inputs: Compile_PdfInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PDFをコンパイル`)
};

const zh_compile_pdf = /** @type {(inputs: Compile_PdfInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`编译 PDF`)
};

const ar_compile_pdf = /** @type {(inputs: Compile_PdfInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تجميع PDF`)
};

const id_compile_pdf = /** @type {(inputs: Compile_PdfInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kompilasi PDF`)
};

const it_compile_pdf = /** @type {(inputs: Compile_PdfInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Compila PDF`)
};

const ru_compile_pdf = /** @type {(inputs: Compile_PdfInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Компиляция PDF`)
};

const pt_compile_pdf = /** @type {(inputs: Compile_PdfInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Compilar PDF`)
};

const ko_compile_pdf = /** @type {(inputs: Compile_PdfInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PDF 컴파일`)
};

/**
* | output |
* | --- |
* | "Compile PDF" |
*
* @param {Compile_PdfInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const compile_pdf = /** @type {((inputs?: Compile_PdfInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Compile_PdfInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_compile_pdf(inputs)
	if (locale === "es") return es_compile_pdf(inputs)
	if (locale === "fr") return fr_compile_pdf(inputs)
	if (locale === "de") return de_compile_pdf(inputs)
	if (locale === "ja") return ja_compile_pdf(inputs)
	if (locale === "zh") return zh_compile_pdf(inputs)
	if (locale === "ar") return ar_compile_pdf(inputs)
	if (locale === "id") return id_compile_pdf(inputs)
	if (locale === "it") return it_compile_pdf(inputs)
	if (locale === "ru") return ru_compile_pdf(inputs)
	if (locale === "pt") return pt_compile_pdf(inputs)
	return ko_compile_pdf(inputs)
});